import styled from 'styled-components'
import MUICardActions from '@mui/material/CardActions'

export const LoginImage = styled.img.attrs({
  src: require('../../assets/sk-login.webp'),
})`
  flex: 0 0 auto;
  width: auto;
  height: 80px;
  object-fit: contain;
  margin-bottom: 8px;
`

export const Root = styled.div`
  /* Fill the Body wrapper, which already offsets the fixed AppBar and caps the
     height to the viewport. Re-applying a header margin / full-viewport height
     here double-counts the offset and forces a spurious vertical scroll. */
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  flex-direction: column;
  margin: 0;
  padding: 8px;
  box-sizing: border-box;
  overflow-y: auto;
`

export const CardActions = styled(MUICardActions)`
  justify-content: center;
  padding: 4px 0;
  gap: 8px;
`
